import produce from 'immer';

import { Types, consultaEPortalSegundaVia } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: consultaEPortalSegundaVia = {
	status: 0,
	requestData: null,
	data: null,
	dataError: null,
};

export default function consultaEPortalSegundaViaReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaEPortalSegundaVia {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_E_PORTAL_SEGUNDA_VIA_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTA_E_PORTAL_SEGUNDA_VIA_SUCCESS: {
				draft.requestData = action.payload.request;
				draft.status = action.payload.response.status;
				draft.data = action.payload.response.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}
			case Types.CONSULTA_E_PORTAL_SEGUNDA_VIA_FAILURE: {
				draft.requestData = action.payload.request;
				draft.status = action.payload.response.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = action.payload.response.data;
				break;
			}
			case Types.CONSULTA_E_PORTAL_SEGUNDA_VIA_CLEAR: {
				draft.requestData = INITIAL_STATE.requestData;
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}
			default:
		}
	});
}
